import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { EventHttpService } from '@core/http/event-http.service';
import { SessionService } from '@src/app/core/session.service';
import { UrlParam } from '@src/app/shared/enums/url-param.enum';
import { EventInterface } from '@src/app/shared/interfaces/event.interface';
import { UIPosition } from '@src/app/shared/models/ui.model';
import { StringUtils } from '@src/app/shared/utils/string-utils';
import { filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-event-checkin',
  templateUrl: './event-checkin.component.html',
})
export class EventCheckinComponent implements OnChanges {
  @Input() event: EventInterface;
  @Input() eventId: number;

  @Output() backToEventDetail = new EventEmitter();

  @ViewChild('cameraInput') cameraInput!: ElementRef<HTMLInputElement>;

  scannedStatus: 'success' | 'fail';
  eventLocationFlagPos = new UIPosition('0.5rem', 'unset', '1.25rem');

  constructor(
    private readonly eventHttpService: EventHttpService,
    private readonly sessionService: SessionService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eventId && this.eventId) {
      this.checkinParticipant();
    }
  }

  checkinParticipant(): void {
    const mode = StringUtils.getParamFromUrl(UrlParam.EventMode);
    const personId = StringUtils.getParamFromUrl(UrlParam.EventParticipantId);

    if (mode && personId) {
      this.sessionService.apiReady$
        .pipe(
          filter(Boolean),
          switchMap(() =>
            this.eventHttpService.checkinParticipant(this.eventId, +personId)
          )
        )
        .subscribe({
          next: () => {
            this.scannedStatus = 'success';
          },
          error: () => {
            this.scannedStatus = 'fail';
          },
        });
    }
  }
}
